"use client";

import { LuShare } from "react-icons/lu";

import { setDialog } from "@/components/app/dialogs/dialog-provider";
import { Button } from "@/components/ui/button";
import { DIALOG } from "@/utils/dialog-routes";
import { cn } from "@/utils/lib";

type WalletShareButtonProps = {
  pageLink: string;
  showLeftOffset?: boolean;
};

export const WalletShareButton = ({
  pageLink,
  showLeftOffset = false,
}: WalletShareButtonProps) => {
  return (
    <Button
      variant="outline"
      className={cn("mr-4 flex items-center gap-2", {
        "ml-6": showLeftOffset,
      })}
      size="sm"
      onClick={() => {
        setDialog(DIALOG.PageShare, {
          open: true,
          params: {
            pageLink,
          },
        });
      }}
    >
      <LuShare className="text-muted" />
      Share
    </Button>
  );
};
